let listTabTitle = document.querySelectorAll('.help-us-tab--mb .tab-list-title__item');
let listTabContent = document.querySelectorAll('.help-us-tab--mb .tab-content .tab-item-container');

if(listTabTitle.length>0){
    listTabTitle.forEach(item=>{
        item.onclick = () =>{
            let att = item.getAttribute('target-tab');
            for(let i = 0; i < listTabTitle.length; i++){
                listTabTitle[i].classList.remove('active');
                if(!listTabContent[i].classList.contains('d-none')){
                    listTabContent[i].classList.add('d-none');
                }
            }
            for(let i = 0; i < listTabContent.length; i++){
                if(listTabContent[i].getAttribute('target-content') == att){
                    if(listTabContent[i].classList.contains('d-none')){
                        listTabContent[i].classList.remove('d-none');
                    }
                }else{
                    if(!listTabContent[i].classList.contains('d-none')){
                        listTabContent[i].classList.add('d-none');
                    }
                }
            }
            item.classList.add('active');
        }
    })
}